import api from "@/services/http/api";
import apiAuth from "@/services/http/apiAuth";

/**
 * Servicio público de noticias.
 * @param {object} opts - { limit, offset, tagId, type }
 *   - type: "NOTICIA" | "SABIAS_QUE" | "HISTORIA" | "NOTA"
 */
export async function listarNoticias({
  limit = 20,
  offset = 0,
  tagId = null,
  type = null,
} = {}) {
  const params = { limit, offset };
  if (tagId) params.tag = tagId;
  if (type) params.type = type;
  const res = await api.get("/news", { params });
  return res.data; // { items, total }
}

export async function obtenerNoticia(id) {
  const res = await api.get(`/news/${id}`);
  return res.data;
}

/**
 * Servicio admin de noticias (requiere auth).
 */
export async function listarNoticiasAdmin({ type = null } = {}) {
  const params = {};
  if (type) params.type = type;
  const res = await apiAuth.get("/news/admin/all", { params });
  return res.data;
}

export async function obtenerNoticiaAdmin(id) {
  const data = await listarNoticiasAdmin();
  const noticia = (data.items || []).find(
    (item) => String(item.id) === String(id),
  );

  if (!noticia) throw new Error("Noticia no encontrada");

  return noticia;
}

export async function crearNoticia(payload) {
  const res = await apiAuth.post("/news", payload);
  return res.data;
}

export async function editarNoticia(id, payload) {
  const res = await apiAuth.put(`/news/${id}`, payload);
  return res.data;
}

export async function eliminarNoticia(id) {
  const res = await apiAuth.delete(`/news/${id}`);
  return res.data;
}

/**
 * Marca/desmarca una imagen cómo portada de una noticia.
 */
export async function setImagenPortada(newsId, imageId) {
  const res = await apiAuth.put(`/news/${newsId}/images/${imageId}`, {
    is_cover: true,
  });
  return res.data;
}

/**
 * Elimina una imagen específica de una noticia (S3 + Files + news_image).
 */
export async function eliminarImagenNoticia(newsId, imageId) {
  const res = await apiAuth.delete(`/news/${newsId}/images/${imageId}`);
  return res.data;
}
